import { render } from "./article.vue?vue&type=template&id=3d620bad&scoped=true"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"

import "./article.vue?vue&type=style&index=0&id=3d620bad&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d620bad"

export default script